import { BaseGateway, type Backend, type BaseGatewayErrorDTO } from '@cplug/frontend-core/gateways'
import type { IdempotencyKeyGenerator } from '@cplug/frontend-core/models'
import type { AxiosResponse } from 'axios'
import { useUUIDGenerate } from '../composables/useUUIDGenerate'
import { useGatewayErrorHandler } from '../composables/useGatewayErrorHandler'
import { setupNavigationAbortInterceptor } from '../composables/useNavigationAbort'
import { useBugsnag } from '#imports'

export class CPIdempotencyKeyGenerator implements IdempotencyKeyGenerator {
  generate (): string {
    return useUUIDGenerate()
  }
}

export default class CPBaseGateway extends BaseGateway {
  constructor () {
    super({
      errorTracker: useBugsnag(),
      idempotencyKeyGenerator: new CPIdempotencyKeyGenerator()
    })
  }

  protected override handleErrorCodes (url: string, response: AxiosResponse<BaseGatewayErrorDTO>): void {
    useGatewayErrorHandler(url, response)
  }

  // Injects AbortSignal on GET requests so in-flight navigations are canceled
  protected override setup (backend: Backend): void {
    super.setup(backend)
    setupNavigationAbortInterceptor(this.api)
  }
}
